import { SDivider } from './Divider.styles';
import { DividerProps } from './Divider.types';

export const Divider = ({ ...props }: DividerProps) => {
  return <SDivider {...props} />;
};
